const nullifyFalsy = (value: string) => {
  if (!value || (typeof value === 'string' && value.trim() === '')) {
    return null;
  }

  return value;
};

export default nullifyFalsy;
